import { Checkbox, Field } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import React from 'react';

let ResultsReportOptionsSection: React.FC<IWorksheetComponent> = () => (
  <ListFieldSection single heading="Report">
    <Field input={<Checkbox />} label="D60, D30, D10, Cu and Cc" name="Results.ReportPSDCurveAnalysis" />
  </ListFieldSection>
);

ResultsReportOptionsSection = withInjectedProps(ResultsReportOptionsSection);

export { ResultsReportOptionsSection };
export default ResultsReportOptionsSection;
